import { transition, trigger, query, style, animate, group, animateChild } from '@angular/animations';

export const routesAnimation =
    trigger('routeAnimations', [
        transition('Intro => Feed', [
            query(':enter', style({ }), { optional: true }),
            query(':leave', style({ }), { optional: true }),
            group([
                query(':enter', [
                    style({ transform: 'translateY(100%)', opacity: 0 }),
                    animate('.2s ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
                ], { optional: true }),
                query(':leave', [
                    style({ transform: 'translateY(0%)', opacity: 1 }),
                    animate('.2s ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
                ], { optional: true }),
            ])
        ]),
        transition('Feed => Intro', [
            query(':enter', style({}), { optional: true }),
            query(':leave', style({}), { optional: true }),
            group([
                query(':enter', [
                    style({ transform: 'translateY(-100%)', opacity: 0 }),
                    animate('0.2s ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
                ], { optional: true }),
                query(':leave', [
                    style({ transform: 'translateY(0%)', opacity: 1 }),
                    animate('0.2s ease-in', style({ transform: 'translateY(100%)' , opacity: 0}))
                ], { optional: true }),
            ])
        ]),
        // this is slide effect
        // transition('Intro => Trip', [
        //     query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
        //     group([
        //         query(':enter', [
        //             style({ transform: 'translateX(100%)' }),
        //             animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
        //         ], { optional: true }),
        //         query(':leave', [
        //             style({ transform: 'translateX(00%)' }),
        //             animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)' }))
        //         ], { optional: true }),
        //     ])
        // ]),
        // this is fade effect
        transition('* => Trip', [
            query(':enter, :leave', style({ position: 'fixed', width: '100%', opacity: 0, height: '100%' }), { optional: true }),
            query(':leave', style({}), { optional: true }),
            query (':enter', style({}), { optional: true }),
            group([
                query(':enter', [
                    style({ opacity: 0 }),
                    animate('0.5s ease-out', style({ opacity: 1 }))
                ], { optional: true }),
                query(':leave', [
                    style({ opacity: 0.7 }),
                    animate('0.5s ease-in', style({ opacity: 0 }))
                ], { optional: true }),
            ])
        ]),
    ]);

export const footerAnimation =
    trigger('footerInRouting', [
        transition('Intro => Feed', [
            query(':enter', style({ height: 0, overflow: 'hidden', opacity: 0}), { optional: true }),
            query(':leave', style({ height: 0, overflow: 'hidden', opacity: 0 }), { optional: true }),
            group([
                query(':enter', [
                    style({ height: 0, overflow: 'hidden', opacity: 0 }),
                    animate('.2s ease-out', style({ height: 'auto', overflow: 'visible', opacity: 1}))
                ], { optional: true }),
                query(':leave', [
                    style({ height: 0, overflow: 'hidden', opacity: 0 }),
                    animate('.2s ease-in', style({ height: 'auto', overflow: 'visible', opacity: 1 }))
                ], { optional: true }),
            ])
        ]),
        transition('Feed => Intro', [
            query(':enter', style({height: 0, overflow: 'hidden', opacity: 0}), { optional: true }),
            query(':leave', style({height: 0, overflow: 'hidden', opacity: 0}), { optional: true }),
            group([
                query(':enter', [
                    style({ opacity: '0' }),
                    animate('1.2s ease-out', style({ height: 'auto', overflow: 'visible', opacity: 1 }))
                ], { optional: true }),
                query(':leave', [
                    style({ opacity: '0' }),
                    animate('1.2s ease-in', style({ height: 'auto', overflow: 'visible', opacity: 1 }))
                ], { optional: true }),
            ])
        ]),
        transition('* => Trip', [
            query(':enter, :leave', style({ height: 0, overflow: 'hidden',  opacity: 0, 'z-index': -1 }), { optional: true }),
            query(':leave', style({  }), { optional: true }),
            group([
                query(':enter', [
                    style({ height: 0, overflow: 'hidden',  opacity: 0, 'z-index': -1}),
                    animate('.2s ease-out', style({ height: 'auto', overflow: 'visible', opacity: 0, 'z-index': -1 }))
                ], { optional: true }),
                query(':leave', [
                    style({ height: 0, overflow: 'hidden',  opacity: 0, 'z-index': -1 }),
                    animate('.2s ease-in', style({ height: 'auto', overflow: 'visible', opacity: 0, 'z-index': -1 }))
                ], { optional: true }),
            ])
        ]),
        transition('* => *', [
            query(':enter, :leave', style({ height: 0, overflow: 'hidden',  opacity: 0 }), { optional: true }),
            group([
                query(':enter', [
                    style({ height: 0, overflow: 'hidden',  opacity: 0 }),
                    animate('.2s ease-out', style({ height: 'auto', overflow: 'visible', opacity: 0 }))
                ], { optional: true }),
                query(':leave', [
                    style({ height: 0, overflow: 'hidden',  opacity: 0 }),
                    animate('.2s ease-in', style({ height: 'auto', overflow: 'visible', opacity: 0 }))
                ], { optional: true }),
            ])
        ]),
    ]);
